import React from "react";

import BasicNavbar from "./BasicNavbar";
import SiteFooter from "../../components/SiteFooter";

export default function CookiePolicyPage() {
  return (
    <div className="dark">
      <div className="bg-background relative flex min-h-screen min-h-dvh w-full flex-col overflow-x-hidden overflow-y-auto scroll-smooth">
        <BasicNavbar />
        <main className="relative z-10 flex w-full flex-1 flex-col items-center pt-[calc(6rem+var(--intl-notice-height,0px))] pb-24">
          <section className="w-full max-w-5xl px-6 sm:px-8">
            <h1 className="text-foreground text-2xl font-semibold tracking-tight sm:text-[32px]">
              Cookie 政策
            </h1>
            <div className="text-default-500 mt-4 space-y-6 text-sm leading-relaxed sm:text-base">
              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">什么是 Cookies？</h2>
                <p>
                  Cookies 是网站在你浏览时放置在你的设备上的一些小文本文件，由你的网络浏览器进行处理和储存，在你以后的浏览中也会被读取到。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">
                  Cookies 的类型及用途
                </h2>
                <p>一般来说，根据不同的用途，Cookies 可以分为四种类型：</p>

                <div className="mt-3 space-y-3">
                  <div>
                    <p className="font-medium text-foreground text-sm sm:text-base">(a) 必需的 Cookie</p>
                    <p className="mt-1">
                      这些 Cookie 是必需的，以便让您能够浏览网站并使用其功能，例如设置您的隐私偏好、登录或填写表单。没有这些
                      Cookie，则无法正常提供通过使用我们的网站请求的服务。根据适用法律规定，必需的 Cookie
                      无需征得用户同意。您可以配置您的网络浏览器来阻止必需的 Cookie，但是您可能无法按预期使用网站的某些功能。
                    </p>
                  </div>

                  <div>
                    <p className="font-medium text-foreground text-sm sm:text-base">(b) 性能 Cookie</p>
                    <p className="mt-1">
                      这些 Cookie 收集访问者如何使用网站的信息，例如访问者最常访问哪些页面，以及访问者如何浏览网站。这些 Cookie
                      帮助我们提高网站的用户友好性，从而增强用户体验。性能 Cookie 收集的进一步信息可能包括，例如：所用的互联网浏览器和操作系统、您以前访问过的网站域名、访问次数、平均访问持续时间和访问的页面。
                      这些 Cookie 收集的信息是聚合的，通常无法与特定的自然人联系起来。在某种程度上，在给定的情况下，与性能
                      Cookie 相关的处理信息应被视为个人数据，根据法律规定，处理这类信息应征得用户同意。
                    </p>
                  </div>

                  <div>
                    <p className="font-medium text-foreground text-sm sm:text-base">(c) 功能 Cookie</p>
                    <p className="mt-1">
                      这些 Cookie 能使网站记住您做出的选择或输入的信息（如您的用户名、语言或所在地区），并提供增强的、更个性化的功能。这些
                      Cookie 还用于启用所请求的功能，如播放视频。在某种程度上，在给定的情况下，与性能 Cookie
                      相关的处理信息应被视为个人数据，根据法律规定，处理这类信息应征得用户同意。
                    </p>
                  </div>

                  <div>
                    <p className="font-medium text-foreground text-sm sm:text-base">(d) 营销 Cookie</p>
                    <p className="mt-1">
                      营销 Cookie（也称为定向或广告 Cookie）用于在第三方网站上发布与您和您的兴趣更相关的广告。这些 Cookie
                      还用于限制您观看广告的次数，以及用于帮助衡量广告活动的效果。根据法律规定，处理与营销 Cookie（如有）相关的个人数据应征得用户同意。
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </section>
        </main>
        <SiteFooter />
      </div>
    </div>
  );
}

